import React from "react";
import FetchApiCtx from "./FetchApiCtx";

import testData from "../testdata"

const FetchApiProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    return (
        <FetchApiCtx.Provider value={{
            getData: async () => {
                //return testData;

                const resp = await fetch("https://www.caspianwebmet.com/dashboardData.php");
                return await resp.json();
            },

            getSeriesData: async (paramIssue: number) => {
                const end = Date.now();
                const start = end - 30 * 24 * 60 * 60 * 1e3;

                const resp = await fetch(`https://www.caspianwebmet.com/getJson.php?start=${start}&end=${end}&parser=NumericValue&issueId=${paramIssue}&amiLogin=1`);

                console.log('resp: ', resp)

                return await resp.json();
            },
        }}>{children}</FetchApiCtx.Provider>
    );
}

export default FetchApiProvider;